import { render, staticRenderFns } from "./DSPayment.vue?vue&type=template&id=23258a76&"
import script from "./DSPayment.vue?vue&type=script&lang=js&"
export * from "./DSPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports